import React, { ReactNode } from "react";
import styles from "./Modal.module.scss";
import Button from "../button/Button";
import { useTranslation } from "react-i18next";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  onSubmit?: () => void;
  footer?: boolean;
  btn_text?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  footer = true,
  btn_text,
}) => {
  const { t } = useTranslation("translation");

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {title && <h2 className={styles.modalTitle}>{title}</h2>}
        <div className={styles.modalContent}>{children}</div>
        {footer ? (
          <div className={styles.btns}>
            <Button className={styles.closeBtn} onClick={onClose}>
              {t("close")}
            </Button>
            <Button onClick={onSubmit}>
              {btn_text ? btn_text : t("submit")}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Modal;
